import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Building, Shield } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function CompanySection({ token, tenant, isOwner }) {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(tenant?.name || '');

  const handleSave = async () => {
    setLoading(true);
    try {
      await axios.patch(`${API}/tenants/current`, { name }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Paramètres mis à jour');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur de mise à jour');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card data-testid="company-settings-card">
      <CardHeader>
        <div className="flex items-center gap-2">
          <Building className="w-5 h-5 text-muted-foreground" />
          <CardTitle className="font-heading">Entreprise</CardTitle>
        </div>
        <CardDescription>Informations de votre entreprise</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="company-name">Nom de l'entreprise</Label>
          <Input
            id="company-name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={!isOwner}
            data-testid="company-name-input"
          />
          {!isOwner && (
            <p className="text-sm text-muted-foreground flex items-center gap-1">
              <Shield className="w-3 h-3" />
              Seuls les owners peuvent modifier les paramètres
            </p>
          )}
        </div>
        <div className="space-y-2">
          <Label>Slug</Label>
          <Input value={tenant?.slug || ''} disabled className="bg-muted" data-testid="company-slug-input" />
          <p className="text-sm text-muted-foreground">Le slug ne peut pas être modifié</p>
        </div>
        {isOwner && (
          <Button onClick={handleSave} disabled={loading} data-testid="save-company-btn">
            {loading ? 'Sauvegarde...' : 'Sauvegarder'}
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
